import { API_URL } from '../../../app-config/constants';
import AnytimeFeedbackDefaultDto from '../../../types/AnytimeFeedbackDefaultDto';
import { get, put } from '../request';

const addId = (defaults: AnytimeFeedbackDefaultDto) => ({
    ...defaults,
    id: 'anytimefeedbackdefault',
});

getAnytimeFeedbackDefault.operation = 'READ';
export function getAnytimeFeedbackDefault(): Promise<AnytimeFeedbackDefaultDto> {
    return get<AnytimeFeedbackDefaultDto>(`${API_URL}/anytime-feedback-default`).then(addId);
}

updateAnytimeFeedbackDefault.operation = 'COMMAND';
export function updateAnytimeFeedbackDefault(
    requestFeedbackDefault: AnytimeFeedbackDefaultDto
): Promise<AnytimeFeedbackDefaultDto> {
    return put<AnytimeFeedbackDefaultDto>(`${API_URL}/anytime-feedback-default`, {
        postData: requestFeedbackDefault,
    }).then(addId);
}
